// Standards-based ICS (RFC 5545) calendar file generation.
// Phase 1: RPLAW -> Calendar only, no mailbox access, no sync back.

function escIcs(s) {
  return String(s || "")
    .replace(/\\/g, "\\\\")
    .replace(/;/g, "\\;")
    .replace(/,/g, "\\,")
    .replace(/\r?\n/g, "\\n");
}

function icsDate(iso) {
  return iso.replace(/-/g, "");
}

function icsDateTime(iso, hm) {
  return `${iso.replace(/-/g, "")}T${hm.replace(":", "")}00`;
}

function icsStamp(d) {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getUTCFullYear()}${p(d.getUTCMonth() + 1)}${p(d.getUTCDate())}T${p(d.getUTCHours())}${p(d.getUTCMinutes())}${p(d.getUTCSeconds())}Z`;
}

export function buildIcs({ title, description, date, allDay, startTime, endTime, location, reminderDays }) {
  const uid = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`) + "@rplaw";
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//RPLAW//Case & Deadline Manager//LT",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTAMP:${icsStamp(new Date())}`,
  ];
  if (allDay) {
    lines.push(`DTSTART;VALUE=DATE:${icsDate(date)}`);
    const end = new Date(date + "T00:00:00");
    end.setDate(end.getDate() + 1);
    const p = (n) => String(n).padStart(2, "0");
    lines.push(`DTEND;VALUE=DATE:${end.getFullYear()}${p(end.getMonth() + 1)}${p(end.getDate())}`);
  } else {
    lines.push(`DTSTART:${icsDateTime(date, startTime || "10:00")}`);
    if (endTime) lines.push(`DTEND:${icsDateTime(date, endTime)}`);
  }
  lines.push(`SUMMARY:${escIcs(title)}`);
  if (description) lines.push(`DESCRIPTION:${escIcs(description)}`);
  if (location) lines.push(`LOCATION:${escIcs(location)}`);
  if (reminderDays && reminderDays !== "none") {
    lines.push("BEGIN:VALARM", `TRIGGER:-P${reminderDays}D`, "ACTION:DISPLAY", `DESCRIPTION:${escIcs(title)}`, "END:VALARM");
  }
  lines.push("END:VEVENT", "END:VCALENDAR");
  return lines.join("\r\n");
}

export function downloadIcs(filename, ics) {
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
